// extracted by mini-css-extract-plugin
export default {"mCard":"sC-z","image":"tC-z","imageNoBackground":"uC-z","imageHasCategory":"vC-z","fullWidth":"wC-z"};